module.exports = __webpack_public_path__ + "img/auth-status-checking-icon.1f061096.svg";